import React from 'react';
import { Mail, MapPin, Phone } from 'lucide-react';
import { companyInfo } from '../mockData';

const Footer = () => {
  return (
    <footer className="bg-emerald-950 text-white py-12">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-6xl mx-auto">
          {/* Main Footer Content */}
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-8">
            {/* Company Info */}
            <div>
              <h3 className="text-2xl font-bold text-amber-400 mb-4">
                {companyInfo.name}
              </h3>
              <p className="text-emerald-200 leading-relaxed">
                Perkhidmatan kewangan profesional untuk penjawat awam dan badan berkanun di Sarawak.
              </p>
            </div>

            {/* Contact Info */}
            <div>
              <h4 className="text-lg font-semibold text-amber-400 mb-4">Hubungi Kami</h4>
              <div className="space-y-3">
                <div className="flex items-center gap-3">
                  <Phone className="h-5 w-5 text-amber-400" />
                  <a href={`tel:${companyInfo.phone}`} className="text-emerald-200 hover:text-amber-400 transition-colors duration-300">
                    {companyInfo.phoneFormatted}
                  </a>
                </div>
                <div className="flex items-center gap-3">
                  <Mail className="h-5 w-5 text-amber-400" />
                  <a href={`mailto:${companyInfo.email}`} className="text-emerald-200 hover:text-amber-400 transition-colors duration-300">
                    {companyInfo.email}
                  </a>
                </div>
                <div className="flex items-center gap-3">
                  <MapPin className="h-5 w-5 text-amber-400" />
                  <span className="text-emerald-200">{companyInfo.location}</span>
                </div>
              </div>
            </div>

            {/* Business Hours / Additional Info */}
            <div>
              <h4 className="text-lg font-semibold text-amber-400 mb-4">Waktu Operasi</h4>
              <div className="space-y-2 text-emerald-200">
                <p>Isnin - Jumaat: 9:00 AM - 6:00 PM</p>
                <p>Sabtu: 9:00 AM - 1:00 PM</p>
                <p>Ahad & Cuti Umum: Tutup</p>
              </div>
            </div>
          </div>

          {/* Divider */}
          <div className="border-t border-emerald-800 my-8"></div>

          {/* Bottom Footer */}
          <div className="flex flex-col md:flex-row justify-between items-center gap-4 text-emerald-300 text-sm">
            <p>
              &copy; {new Date().getFullYear()} {companyInfo.name}. Hak Cipta Terpelihara.
            </p>
            <div className="flex gap-6">
              <a href="#" className="hover:text-amber-400 transition-colors duration-300">
                Dasar Privasi
              </a>
              <a href="#" className="hover:text-amber-400 transition-colors duration-300">
                Terma & Syarat
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;